import { render, staticRenderFns } from "./BandTypeField.vue?vue&type=template&id=13b48ab8"
import script from "./BandTypeField.vue?vue&type=script&lang=js"
export * from "./BandTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports